module.exports = __webpack_public_path__ + "img/touxiao.8621f660.gif";